import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '../../../../../globals/classes/base.component';
import { FaqSection } from '../../../../classes/http-responses';
import { FAQsService } from '../../../../services/faqs.service';
import { GeneralQuestionsComponent } from '../../general-questions/general-questions.component';
import { LanguageService } from '@ibank-globals/language';
import { IErrorDescription } from '@ibank-globals/error';
import { ErrorHandler } from '../../../../../globals/classes/errorHandler';
import { finalize } from 'rxjs/operators/finalize';
import { AppSettings } from '../../../../app.settings';

@Component({
	selector: 'questions-section',
	template: require('./questions-section.component.html'),
})
export class QuestionsSectionComponent extends BaseComponent implements OnInit {
	@Input() userType: string;
	public isRebrading = AppSettings.isRebrading;

	public faqSections: FaqSection[];
	public isLoading: boolean;

	constructor(private modalService: NgbModal, private _langSvc: LanguageService) {
		super();
	}

	public ngOnInit(): void {
		this.setupSubscriptions();
	}

	public toggleSection(section: FaqSection): void {
		let modalRef = this.modalService.open(GeneralQuestionsComponent);
		modalRef.componentInstance.section = section;
	}

	private loadFaqs(lang: string) {
		this.isLoading = true;
		FAQsService.getFaqSections(lang, this.userType)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe(
				(faqSectionsFromApi) => {
					this.handleFaqSectionResponse(faqSectionsFromApi);
				},
				(error) => this.handleFaqsError(error)
			);
	}

	private setupSubscriptions(): void {
		this.mortalize(this._langSvc.activeLanguage$).subscribe((lang) => this.loadFaqs(lang));
	}

	private handleFaqSectionResponse(faqSections: FaqSection[]): void {
		this.faqSections =
			faqSections == null ? [] : faqSections.filter((s) => !!s.faqs && s.faqs.length > 0);
	}

	private handleFaqsError(error: IErrorDescription) {
		ErrorHandler.newError(error);
	}
}
